import { Alert } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyAlert = styled(Alert, {
    name: 'StyAlert',
})(({ theme }) => ({
    alignItems: 'center',
    borderRadius: '0.5rem',
    fontSize: '14px',
    '& a': {
        color: theme.palette.primary.main,
        textDecorationLine: 'underline',
    },
}));
